// extracted by mini-css-extract-plugin
export default {"timestamp":"d1POwT848jMyj4ZGy80s"};